import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDashboardBackPath(fallbackPath: string) {
  if (typeof window === "undefined") {
    return fallbackPath;
  }

  try {
    const prev = window.sessionStorage.getItem(
      "orkestria-previous-dashboard-route",
    );

    if (prev && prev.startsWith("/dashboard")) {
      return prev;
    }
  } catch {
    return fallbackPath;
  }

  return fallbackPath;
}
